import 'UI/Widget/Forms/Render/Light';
import 'UI/Widget/Forms/ViewForm';
import 'UI/Widget/Forms/Tabs';
import 'Cadastre/UI/Cadnum';
import 'Cadastre/UI/Owners';
import 'Cadastre/Data/Cadnums';
import 'Cadastre/Data/Owners';

/** @namespace Accounting.UI */
NS('Cadastre.UI');

/**
 * @class
 * @extends UI.Widget.Form
 * @extends UI.Widget.Forms.Render.Light
 */

Cadastre.UI.Cadastre = Class(
	UI.Widget.Form,
	UI.Widget.Forms.Tabs,
	UI.Widget.Forms.Render.Light, {
		showCloseBtn: true,
		formButtons: [],
		title: "Кадастровый номер",
		titleField: null,

		tabs: [
			{
				title: 'Информация',
				name: 'cadnum',
				class: 'Cadastre.UI.Cadnum',
				options: {}
			},
			{
				title: 'Владельцы',
				name: 'owners',
				class: 'Cadastre.UI.Owners',
				accessKey: 'Cadastre.Owners',
				options: {},
			}
		],

		cadnumsDataClass: 'Cadastre.Data.Cadnums',
		cadnumsDS: null,

		id: null,
		item: null,

		initialize: function (options) {
			this.ParentCall();

			this.cadnumsDS = Util.create(this.cadnumsDataClass);
		},

		/** @inheritDoc */
		render() {
			this.ParentCall();
			this.renderContainer();
			this.$('.overlay-loader').show();

			if (this.item) {
				this.renderItem ();
				return this;
			} else if (this.id) {
				this.cadnumsDS.getDocument({ id: this.id }, ({item}) => {
					this.item = item;
					this.renderItem();
				});
			} else this.$('.overlay-loader').hide();

			return this;
		},
		renderItem () {
			_.find(this.tabs, {name: 'cadnum'}).options = {
				item: this.item
			};

			_.find(this.tabs, {name: 'owners'}).options = {
				source: new Cadastre.Data.Owners(),
				args: {
					filter: {
						cadnum: this.item.cadnum
					}
				}
			};
			this.$('.overlay-loader').hide();
			this.renderTabs().appendTo(this.$body);
			this.tabShow('cadnum');
		}
	}
);